import React, { useMemo } from 'react';

import { CONFLUENCE_SSR_CHUNKS_WINDOW_KEY } from '../utils/ssrChunks.ts';

type SsrChunkTrackerProps = {
	name: string;
};

export const SsrChunkTracker = ({ name }: SsrChunkTrackerProps): React.JSX.Element => {
	const serializedName = useMemo(() => JSON.stringify(name), [name]);
	const scriptHtml = useMemo(
		() =>
			`<script>if(window["__SSR_RENDERED__"]){window["${CONFLUENCE_SSR_CHUNKS_WINDOW_KEY}"]=window["${CONFLUENCE_SSR_CHUNKS_WINDOW_KEY}"]||[];window["${CONFLUENCE_SSR_CHUNKS_WINDOW_KEY}"].push(${serializedName})}</script>`,
		[serializedName],
	);

	return (
		<div
			hidden
			suppressHydrationWarning
			data-testid={`ssr-chunk-tracker-${name}`}
			// eslint-disable-next-line react/no-danger
			dangerouslySetInnerHTML={{ __html: scriptHtml }}
		/>
	);
};
